import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Minus } from 'lucide-react';
import { forwardRef, useEffect, useRef, } from 'react';
import { cn } from './cn.js';
/**
 * Token-driven checkbox on a native <input type="checkbox"> (free keyboard +
 * a11y). Supports the indeterminate tri-state for "select all" headers.
 */
export const Checkbox = forwardRef(({ className, label, indeterminate = false, ...props }, forwardedRef) => {
    const localRef = useRef(null);
    // Reflect the tri-state onto the DOM node (no HTML attribute for it).
    useEffect(() => {
        if (localRef.current)
            localRef.current.indeterminate = indeterminate;
    }, [indeterminate]);
    const setRefs = (node) => {
        localRef.current = node;
        if (typeof forwardedRef === 'function')
            forwardedRef(node);
        else if (forwardedRef)
            forwardedRef.current = node;
    };
    return (_jsxs("label", { className: "inline-flex cursor-pointer items-center gap-2 select-none", children: [_jsxs("span", { className: "relative inline-grid size-5 shrink-0 place-items-center", children: [_jsx("input", { ref: setRefs, type: "checkbox", className: cn('peer size-5 cursor-pointer appearance-none rounded border border-input bg-card ' +
                            'transition-colors duration-[var(--dur-fast)] ' +
                            'checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary ' +
                            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 ' +
                            'disabled:cursor-not-allowed disabled:bg-disabled disabled:text-disabled-foreground ' +
                            'disabled:border-disabled-foreground disabled:outline-1 disabled:-outline-offset-1 disabled:outline-disabled-foreground', className), ...props }), indeterminate ? (_jsx(Minus, { className: "pointer-events-none absolute size-3.5 text-primary-foreground", "aria-hidden": "true" })) : (_jsx(Check, { className: "pointer-events-none absolute size-3.5 text-primary-foreground opacity-0 peer-checked:opacity-100", "aria-hidden": "true" }))] }), label != null && _jsx("span", { className: "text-sm text-foreground", children: label })] }));
});
Checkbox.displayName = 'Checkbox';
